import { QueryClient } from '@tanstack/solid-query'
import { isValidAppVersion } from './params'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      enabled: isValidAppVersion,
      staleTime: Infinity,
      gcTime: Infinity,
      retry: false,
    },
  },
})
